import React, { useMemo } from 'react';
import PreviewScreen from '../components/PreviewScreen';
import InterviewStart from '../components/Pages/components/PreviewDesktop/InterviewStart';
import PostLeave from '../components/PostLeave';
import RecordingRoom from '../components/recordingRoom';
import FeedbackRoom from '../components/feedbackRoom';
import LiveKitConnected from '../components/LiveKit/LiveKitConnected';
import { ConnectionProvider } from '../components/hooks/useConnection';
import '../platform/scss/platform.scss';

const InterviewPlatformView = ({ component }) => {
    const isLiveKitValid = ['Conference', 'PracticeRoom'].includes(component);
    const ActiveComponent = useMemo(() => {
        switch (component) {
            case 'PreviewScreen':
                return PreviewScreen;
            case 'InterviewStart':
                return InterviewStart;
            case 'PostLeave':
                return PostLeave;
            case 'RecordingRoom':
                return RecordingRoom;
            case 'FeedbackRoom':
                return FeedbackRoom;
            default:
                return null;
        }
    }, [component]);

    return isLiveKitValid ? (
        <ConnectionProvider>
            <LiveKitConnected component={component} />
        </ConnectionProvider>
    ) : ActiveComponent ? (
        <ActiveComponent />
    ) : null;
};

export default InterviewPlatformView;
